import { useEffect } from 'react';

interface UseToolsMenuHotkeyOptions {
  isOpen: boolean;
  close: () => void;
}

// Esc fecha o menu de ferramentas quando aberto.
const useToolsMenuHotkey = ({ isOpen, close }: UseToolsMenuHotkeyOptions): void => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        close();
      }
    };

    // Captura: roda antes dos handlers React (anexados no document), que em
    // vários componentes fazem stopPropagation no onKeyDown.
    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, [isOpen, close]);
};

export default useToolsMenuHotkey;
